import { createHash, randomBytes } from 'crypto';

// API keys are high-entropy random tokens, not low-entropy user passwords —
// a fast cryptographic hash (SHA-256) is the right tool here, not bcrypt.
// bcrypt's deliberate slowness defends against brute-forcing guessable
// secrets; it would just add needless latency to every authenticated
// request without protecting anything a 256-bit random token doesn't
// already resist by construction.
const KEY_PREFIX = 'cbk_'; // "chat bot key" — lets a leaked key be recognized at a glance

export function generateApiKey(): { rawKey: string; keyHash: string } {
  const rawKey = KEY_PREFIX + randomBytes(32).toString('hex');
  return { rawKey, keyHash: hashApiKey(rawKey) };
}

export function hashApiKey(rawKey: string): string {
  return createHash('sha256').update(rawKey).digest('hex');
}
